import type { LoaderFunction, MetaFunction } from '@remix-run/cloudflare';
import { redirect } from '@remix-run/cloudflare';
import { Link } from '@remix-run/react';
import { getUserStartPath } from '#app/auth.js';

export const meta: MetaFunction<typeof loader> = () => {
  return [{ title: 'LIFT' }, { description: 'Welcome to LIFT' }];
};

export const loader: LoaderFunction = async ({ context }) => {
  const { user } = context;
  if (!user) throw redirect('/login');

  const userStart = getUserStartPath(user);
  throw redirect(userStart);
};

// https://remix.run/guides/routing#index-routes
export default function Index() {
  return (
    <main>
      <p>
        Empty for now. <Link to="login">Link to login page.</Link>
      </p>
    </main>
  );
}
